import { LoadingIndicator } from 'src/components';

/**
 * FullPageLoadingIndicator - renders a loading indicator in the center of the screen
 * full height and width
 * @returns {JSX.Element}
 */
const FullPageLoadingIndicator = () => {
  return (
    <div
      className="absolute inset-0 h-auto"
      data-testid="full-page-loading-indicator"
    >
      <LoadingIndicator />
    </div>
  );
};

export default FullPageLoadingIndicator;
